import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/general.action'
import getDefaultProfilesList from 'api/general/getDefaultProfiles'

async function getList() {
  return await getDefaultProfilesList()
}

function* defaultProfilesListEffectSaga() {
  try {
    const data = yield call(getList)
    yield put(fromActions.Actions.lmsAllDefaultProfilesSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* defaultprofilesListWatcherSaga() {
  yield takeLatest(fromActions.GENERAL_LMS_PROFILES_DEFAULT_LIST, defaultProfilesListEffectSaga)
}
